if (typeof RelatedProducts === 'undefined') {
    class RelatedProducts extends HTMLElement {
        constructor() {
            super();
            this.isLoaded = false;
            this.swiper = null;
        }

        connectedCallback() {
            if (this.isLoaded) return;
            this.isLoaded = true;

            // Fetch product recommendations immediately
            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('related-products');
                    
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        
                        // Initialize swiper after content is loaded
                        this.initializeSwiper();
                    }
                })
                .catch(e => {
                    console.error('Error fetching product recommendations:', e);
                });
        }

        initializeSwiper() {
            const swiperContainer = this.querySelector('.swiper');
            if (!swiperContainer || this.swiper) return;

            // Wait for Swiper to be available
            whenReady('Swiper', () => {
                try {
                    const sliderOptions = {
                        loop: false,
                        slidesPerView: "auto",
                        spaceBetween: 0,
                        watchSlidesProgress: true,
                        mousewheel: {
                            forceToAxis: true
                        },
                        navigation: {
                            nextEl: this.closest(".shopify-section").querySelector('.swiper-next'),
                            prevEl: this.closest(".shopify-section").querySelector('.swiper-prev'),
                        },
                        a11y: true,
                        breakpoints: {
                            768: {
                                slidesPerView: 2
                            }
                        },
                        modules: [window.Swiper.Mousewheel, window.Swiper.Navigation, window.Swiper.A11y],
                    };
                     
                    this.swiper = new window.Swiper(swiperContainer, sliderOptions);

                    // Add resize listener after swiper is initialized
                    window.addEventListener('resize', this.handleResize);
                } catch (error) {
                    console.error('Failed to initialize Swiper:', error);
                }
            });
        }

        disconnectedCallback() {
            // Clean up swiper 
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    }

    if (!window.customElements.get('related-products')) {
        window.customElements.define('related-products', RelatedProducts);
    }
}

